import React from "react";
import "./underDoo.css";

const underDevelopment = () => {
  return (
    <div className="under-dev-container">
      <div className="under-dev-content">
        <h1>Adv. Faiz Syed's Website</h1>
        <h1>⚙️ Website Under Development ⚙️</h1>
        <h3>
          Coming Soon! We’re working on website. <br />
          Please check back soon!
        </h3>
        <button onClick={() => window.history.back()} className="back-button">
          ← Go Back
        </button>
      </div>
    </div>
  );
};

export default underDevelopment;
